import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { EspecialidadeVeiculoService } from '../services/especialidade-veiculo.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { AuthService } from '../services/auth.service';

@Component({
	selector: 'app-especialidade-veiculo',
	templateUrl: './especialidade-veiculo.component.html',
	styleUrls: ['./especialidade-veiculo.component.css'],
	animations: [loadingFade, modal, alert]
})
export class EspecialidadeVeiculoComponent implements OnInit {
	public loading = false;
	public especialidadesveiculo = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	

	constructor(private especialidadeVeiculoSvc: EspecialidadeVeiculoService,
		private route: ActivatedRoute,
		private perfilUsuarioSvc: PerfilUsuarioService,
		private authSvc: AuthService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 


		this.pegaEspecialidadesVeiculo();
	}

	pegaEspecialidadesVeiculo() {
		this.especialidadesveiculo = [];
		this.loading = true;
		this.especialidadeVeiculoSvc.getEspecialidadesVeiculo().then((data: any[]) => {
			this.especialidadesveiculo = data;
			this.count = this.especialidadesveiculo.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaEspecialidade(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.especialidadeVeiculoSvc.apagaEspecialidadeVeiculo(id).then((data) => {
					this.pegaEspecialidadesVeiculo();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	onChangeStatus(especialidade_veiculo_id, event){
		this.loading = true;
		let status = event.srcElement.checked == true ? '1' : '0';
		let toSend = ({
		  'especialidade_veiculo_id': especialidade_veiculo_id,
		  'status': status,
		});

		this.especialidadeVeiculoSvc.editaEspecialidadeVeiculoStatus(toSend).then((data) => {
		  this.loading = false;
		  Swal.fire({
			type: 'success',
			title: 'Status alterado com sucesso!'
		  });
		}).catch(err => {
		  console.log(err);
		  this.loading = false;
		  Swal.fire({
			type: 'error',
			title: 'Ops! Algo de errado aconteceu!',
			text: 'Tente novamente mais tarde.'
		  });
		});
	}

}
